import styled from 'styled-components';
import ufo from '../images/ufo.svg';
import roadmap from '../images/roadmap.svg';
import eth from '../images/eth.svg';
import {CountDownClock} from './Countdown';

function RoadMap() {
    return (
        <>
        <RoadMapWrapper>
            <img className='ufo' src={ufo} alt="UFO" />
            <div className="waves">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 200">
                <path fill="#233632" d="M0,4.11C273,42.2,822-31,1920,16.91V100H0Z">
                <animate repeatCount="indefinite" attributeName="d" dur="15s" attributeType="XML" values="M0 77 C 473,283 822,-40 1920,116 V 359 H 0 V 67 Z; M0 77 C 473,-40 1222,283 1920,136 V 359 H 0 V 67 Z; M0 77 C 973,260 1722,-53 1920,120 V 359 H 0 V 67 Z; M0 77 C 473,283 822,-40 1920,116 V 359 H 0 V 67 Z"/>
                </path>
            </svg>
            </div>
            <div className="headline">
                <h2>R<span>o</span>ad Map</h2>
                <img src={roadmap} alt="Road Map" />
            </div>

            <div className="roadmap-timeline">
                <div className="roadmap-item done">
                    <div className="icon-wrapper">
                        <div className="icon">
                             <span>
                             <svg width="30px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224 .0001c-123.8 0-224 87.99-224 232.5c0 111.7 134.2 224.5 194.9 269.9c17.25 12.87 41 12.87 58.25 0C313.8 456.1 448 344.2 448 232.5C448 87.99 347.8 .0001 224 .0001zM176 319.1h-32c-44.12 0-80-35.87-80-79.1c0-8.874 7.125-15.1 16-15.1h32c44.12 0 80 35.87 80 79.99C192 312.9 184.9 319.1 176 319.1zM304 319.1h-32c-8.875 0-16-7.125-16-15.1c0-44.12 35.88-79.99 80-79.99h32c8.875 0 16 7.124 16 15.1C384 284.1 348.1 319.1 304 319.1z"/></svg>
                             </span>
                        </div>
                    </div>
                    <div className="copy">
                        <h3>The Art</h3>
                        <p>With the help of human talent and Alien technology, we finished a collection of 5,000 randomly generated art.</p>
                        <p className="highlighted">5 Alien Species</p>
                    </div>
                </div>
                <div className="roadmap-item left done">
                    <div className="copy">
                        <h3>Mint Day</h3>
                        <p className="highlighted">
                            <li>WL: <img src={eth} alt="eth" /><b>0.04</b></li> 
                            <li>Public: <img src={eth} alt="eth" /><b>0.06</b></li>
                        </p>
                        <p className="highlighted"><CountDownClock/></p>
                    </div>
                    <div className="icon-wrapper">
                        <div className="icon">
                             <span>
                             <svg width="24" height="39" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" fill="#fff"><path d="M11.818 29.201 0 22.133 11.818 39l11.818-16.867L11.818 29.2Z"/><path d="M23.636 19.866 11.818 0 0 19.866l11.818 7.068 11.818-7.068Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h23.636v39H0z"/></clipPath></defs></svg>
                             </span>
                        </div>
                    </div>
                </div>
                <div className="roadmap-item">
                    <div className="icon-wrapper">
                        <div className="icon">
                             <span>
                             <svg width="40px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#fff" d="M640 162.8c0 6.917-2.293 13.88-7.012 19.7l-49.96 61.63c-6.32 7.796-15.62 11.85-25.01 11.85c-7.01 0-14.07-2.262-19.97-6.919L480 203.3V464c0 26.51-21.49 48-48 48H208C181.5 512 160 490.5 160 464V203.3L101.1 249.1C96.05 253.7 88.99 255.1 81.98 255.1c-9.388 0-18.69-4.057-25.01-11.85L7.012 182.5C2.292 176.7-.0003 169.7-.0003 162.8c0-9.262 4.111-18.44 12.01-24.68l135-106.6C159.8 21.49 175.7 16 191.1 16H225.6C233.3 61.36 272.5 96 320 96s86.73-34.64 94.39-80h33.6c16.35 0 32.22 5.49 44.99 15.57l135 106.6C635.9 144.4 640 153.6 640 162.8z"/></svg>
                             </span>
                        </div>
                    </div>
                    <div className="copy">
                        <h3>Clothing Line</h3>
                        <p>Our partnership with <a href="https://whitealiens.com" target="_blank" rel="noreferrer">WhiteAliens.com</a> will give us the tools to build the Alien Fam clothing line with the community. T-Shirts, Jackets, Hoodies, Sunglasses, and more. Long-term holders will have the option to vote on quality, material, style, and designs.</p>
                    </div>
                </div>
                <div className="roadmap-item left">
                    <div className="copy">
                        <h3>ALNFM Coin</h3>
                        <p style={{marginBottom: '80px'}}>More information about the ALNFM Coin will be available after the Mint.</p>
                    </div>
                    <div className="icon-wrapper">
                        <div className="icon">
                             <span>
                             <svg width='50px' height='50px' style={{marginBottom: '-5px'}}  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs></defs><path fill="#fff" d="m12.72 10.16-.15.15Zm19 6v.49a12.35 12.35 0 0 1 .49 3.35 12.23 12.23 0 0 1-9.31 11.86l-.57.66-.27.28a13 13 0 0 0 9.58-18.5 12.26 12.26 0 0 1 .1 1.36ZM5.25 29.91l1.32-.33-.52-.77Zm12.08 7.55.64-1.2-.92-.13ZM2.46 23l1.34.23-.16-.91Zm26.91 1.36a25.29 25.29 0 0 1-2.09 2.43c-.6.63-1.21 1.24-1.78 1.9-.7.81-1.36 1.66-2 2.48a11.77 11.77 0 0 0 4.83-2.92 11.73 11.73 0 0 0 3.31-10 17.56 17.56 0 0 1-.9 3.75 9.5 9.5 0 0 1-1.37 2.37Zm-15 6.46a12.28 12.28 0 0 1-3-2.2 12.2 12.2 0 0 1-1.31-15.72 8.39 8.39 0 0 1 1.49-2.73c-.25.21-.48.43-.71.66A13 13 0 0 0 15 32l-.12-.22c-.16-.34-.34-.65-.52-.95ZM9.85 21v-.69a.13.13 0 0 0 0-.09 1.91 1.91 0 0 1-.22-2 .2.2 0 0 0 0-.13c0-.43-.08-.86-.11-1.29a11.29 11.29 0 0 1 .1-2v-.3a11.72 11.72 0 0 0 2 13.84A11.9 11.9 0 0 0 13.85 30l-2.39-4.1a4.54 4.54 0 0 1-.59-2.12.47.47 0 0 0-.19-.42 1.71 1.71 0 0 1-.49-.71A3.83 3.83 0 0 1 9.85 21ZM32.22 7.36 31 8l.67.65Zm-7.46 29.58.09-1.36-.89.26ZM40 20a20 20 0 0 1-27.78 18.43A20 20 0 0 1 0 20 20 20 0 0 1 27.78 1.57 20 20 0 0 1 40 20Zm-.57 0a19.43 19.43 0 1 0-1.53 7.56A19.34 19.34 0 0 0 39.43 20Zm-.5 0a18.78 18.78 0 0 1-1.49 7.37 18.9 18.9 0 0 1-10.07 10.07 19 19 0 0 1-14.74 0A18.9 18.9 0 0 1 2.56 27.37a19 19 0 0 1 0-14.74A18.9 18.9 0 0 1 12.63 2.56a19 19 0 0 1 14.74 0 18.9 18.9 0 0 1 10.07 10.07A18.78 18.78 0 0 1 38.93 20Zm-1.11-2.39-2.72.24v.36l1.2-.11.11 1.15h.29l-.1-1.14.93-.09.12 1.33h.29Zm-1-4-2.61.81.11.35 2-.63-1.6 1.94.1.35 2.61-.81-.1-.34-2 .62 1.61-1.9Zm-1-2.27-2.46 1.2.77 1.56.26-.13-.6-1.24.87-.42.52 1.06.26-.13-.52-1.06.79-.39.6 1.22.26-.13Zm-.63-1.05-2.33 1.44.14.27 2.33-1.43Zm-3.52-.21 1 1.32.23-.18-.78-1L34 8.7l-.22-.29Zm-1.91-1.92.27.26.68-.33.82.8-.32.69.27.26 1.16-2.68-.22-.22Zm-1.55-3.63a1 1 0 0 1 .85.94h.42a1.38 1.38 0 0 0-1.23-1.36h-.08ZM28 5v1h.32V5Zm0 1.85h.14v-.44h-.1A.94.94 0 0 1 28 4.54v-.43a1.36 1.36 0 0 0 0 2.71Zm-2.35-2.8a.9.9 0 0 1-.28.49l.3.27a1.31 1.31 0 0 0 .38-.67 1.14 1.14 0 0 0 0-.52l-.39.06a.92.92 0 0 1-.01.37ZM25 3.13a.33.33 0 0 0 .41-.22.32.32 0 0 0-.21-.41.33.33 0 0 0-.42.21.34.34 0 0 0 .22.42Zm-.88 1.69a.33.33 0 0 0 .62.2.33.33 0 0 0-.21-.42.33.33 0 0 0-.4.22Zm-.63-.7h.4a.84.84 0 0 1 .11-.61.81.81 0 0 1 .21-.3l-.29-.28a1.37 1.37 0 0 0-.29.42 1.21 1.21 0 0 0-.13.77Zm-4.66-.9a1.57 1.57 0 0 0 3.11 0h.19v-.36h-1.32v-.4h-.37v1.16h.37v-.4h.65a1.08 1.08 0 0 1-2.13 0Zm-3.3.59h.39a.28.28 0 0 1 0-.09.86.86 0 0 1 1-.78.87.87 0 0 1 .08 1.73v-.54h-.3v1h.3a1.27 1.27 0 1 0-1.41-1.39.62.62 0 0 0-.05.07Zm-3.6 2.52.44-.21a1.08 1.08 0 0 1 2-.89l.44-.2a1.57 1.57 0 1 0-2.85 1.3Zm1.68-1.49-1 .47.15.34 1-.48ZM6.76 7.4l1.82 2 .27-.24-.71-.76-.79-.83 2.14 1 .21-.19-.81-2.19.74.88.71.79.27-.24-1.82-2-.35.31.82 2.26-2.15-1.1ZM5.43 9 7 11.53l.23-.29-.41-.64.7-.91.73.23.22-.29-2.8-.84Zm-1.55 2.42 2.36 1.39.18-.31-1-.61.58-1-.25-.15-.58 1-.81-.48.64-1.15-.26-.11Zm-1.54 3.83 2.6.86.11-.34-2-.67 2.44-.63.11-.35-2.6-.86-.11.34 2 .67-2.44.63Zm-.47 2.46 2.7.46.29-1.71-.29-.05-.23 1.35-1-.16.2-1.17-.29-.05-.2 1.17-.87-.15.23-1.33-.25-.07Zm-.09 1.23 2.72.18v-.36l-2.7-.18Zm0 2.29 2.73-.08v-1.66h-.34v1.29l-2.43.08Zm3.14 2.56-.07-.36-.74-.13-.2-1.13.66-.38-.07-.36-2.5 1.5.06.31Zm-1.09 4.72 2.5-1.09-.14-.33-1 .42-1 .5 1.65-1.71-.11-.25-2.39.06 1.07-.43 1-.42-.14-.33L2.74 26l.19.43 2.4-.08-1.69 1.74ZM5 30.29l2.85-.67-.21-.31-.74.19-.64-.95.45-.61-.21-.31L4.79 30Zm1.76 2.21 2.05-1.8-.24-.27-.91.79-.75-.86-.23.2.76.86-.7.62-.88-1-.22.19Zm3.16 2.65L11.55 33l-.29-.21L10 34.43l.15-2.51-.29-.22-1.63 2.2.29.21 1.26-1.7-.15 2.53Zm3.47-1.21-1.54-.81-.14.26 1.22.65-.45.85-1.05-.55-.14.26 1.05.55-.41.78-1.2-.63-.14.26 1.52.8Zm.88.36-.33-.13-1 2.53.34.13Zm1.93.63-1.59-.47-.08.28 1.24.37-.69 2.34.35.1Zm2.64.44-.37-.06-.35.67-1.12-.16-.15-.75h-.37l.65 2.86h.31ZM20.35 34a5.76 5.76 0 0 0 1-.57 13.46 13.46 0 0 0 10-20.7 9 9 0 0 0-1.1-2.37 9.33 9.33 0 0 0-2.56-2.64 9.54 9.54 0 0 0-4.79-1.6 8.53 8.53 0 0 0-1.75 0 1.11 1.11 0 0 1-.26 0 8.35 8.35 0 0 0-1.5 0 11.82 11.82 0 0 0-2.41.54 13.55 13.55 0 0 0-1.75.75 13.45 13.45 0 0 0-4.69 22.08 13.22 13.22 0 0 0 4.88 3.13.83.83 0 0 0 .07.13A2.91 2.91 0 0 0 16.75 34a3.59 3.59 0 0 0 1.3.31 4.65 4.65 0 0 0 2.3-.31ZM23 37.86l-.27-2.72h-.36l.11 1 .15 1.14-1.11-2.11h-.28l-.67 2.29-.08-1.15-.11-1.06h-.36l.28 2.72.46-.05.67-2.3 1.11 2.13Zm2.29-3.45-.36.1-.05.76-1.1.32-.46-.59-.35.11 1.76 2.33.3-.09Zm2.41 1.91-1.09-2.52-.33.15.48 1.11-1.06.45.12.27 1.05-.45.37.86-1.24.52.11.27Zm3.5-2.18-1.58-2.23-.29.21 1.21 1.71-2.34-.92-.29.21 1.58 2.23.29-.21-1.22-1.72 2.35.93Zm1.8-1.71-1.9-2-1.25 1.21.21.21 1-1 .67.7-.85.82.21.21.85-.82.61.63-1 .94.2.22Zm.81-.94-2.1-1.75-.21.26 2.09 1.76Zm1.35-1.85-2.23-1.54-.93 1.36.24.17.76-1.07 2 1.38Zm1-1.77-2-2.15-.16.33.53.55-.51 1-.76-.09-.16.33 2.91.28Zm1.68-5.32L35.16 22l-.08.36 1 .23 1.13.21-2.35.4-.06.26 2 1.36-1.12-.28-1-.23-.08.35 2.67.59.1-.46-2-1.35 2.36-.44Zm.16-2.11-2.7-1.13v.37l.7.32v1.15l-.72.23v.37l2.72-.99ZM5.87 9.19l.73 1.14.57-.73Zm30.37 10.89v.93l1.3-.42Zm-.56 7.73-.94-1-.41.83Zm-15.52 5.32a3.92 3.92 0 0 1-2.19.36 3 3 0 0 1-.78-.19 2 2 0 0 1-.94-.8 7.08 7.08 0 0 1-.38-.66 16.13 16.13 0 0 0-.87-1.57l-.1-.19-.4-.65.4.65v-.09c-.11-.32-.22-.63-.32-.95a4.35 4.35 0 0 1-.22-1.13 7.29 7.29 0 0 1 .14-1.31c.07-.46.15-.93.22-1.39a.84.84 0 0 0 .06-.14 2.33 2.33 0 0 0 0-.37 2.09 2.09 0 0 0 0-.25 2.42 2.42 0 0 0 0-.38v-.26.26-.37c0-.32 0-.64-.07-.95a8.18 8.18 0 0 0-.59-2.07 4.83 4.83 0 0 0-.88-1.42.64.64 0 0 1-.14-.22c-.06-.13 0-.2.14-.2a.91.91 0 0 1 .51.16l.85.59c.15.09.3.16.46.24a.29.29 0 0 0 .13 0 .39.39 0 0 0-.08-.1 4 4 0 0 1-.79-1.08 1.11 1.11 0 0 1-.07-.16c0-.08 0-.12.09-.1l.23.1c.09.05.17.12.26.18a1 1 0 0 0 .5.22.67.67 0 0 0 .53-.23 3.09 3.09 0 0 0 .55-.7c.25-.41.48-.82.73-1.23l-.29.22a4.58 4.58 0 0 1-.91.59c-.26.11-.38.06-.49-.2v-.08a5.33 5.33 0 0 1-.19-1.32 11.07 11.07 0 0 1 .31-3 5.54 5.54 0 0 1 .71-1.79s0 0 0-.06l-.11.06a2.09 2.09 0 0 0-.14.17 5.1 5.1 0 0 0-.71 1.37c-.15.42-.28.85-.42 1.28a.78.78 0 0 0 0 .14 5.54 5.54 0 0 1 0-1 5.66 5.66 0 0 1 .57-1.6c.25-.48.55-.94.82-1.41.19-.32.37-.63.54-.95s0-.23-.15-.23a2.81 2.81 0 0 0-.88.08 7.46 7.46 0 0 0-2.08 1.2 6.83 6.83 0 0 0-1.66 1.8 8.53 8.53 0 0 0-1 2.63 7.65 7.65 0 0 0-.11 2.86h-.11l-.34.12a4.36 4.36 0 0 1-.05-.52v-1.35a8.89 8.89 0 0 1 1.09-4.06 7.06 7.06 0 0 1 .8-1.14h.07c.24-.21.47-.42.72-.62a12 12 0 0 1 2.14-1.38c.37-.19.74-.36 1.11-.52a10.78 10.78 0 0 1 1.81-.63 5.24 5.24 0 0 1 .53-.08c-.27.17-.56.34-.82.53a3.3 3.3 0 0 0-.9 1l.07-.06a7.51 7.51 0 0 1 2.44-1.28c.38-.12.77-.21 1.16-.32h2c.24 0 .48 0 .71.07a8.18 8.18 0 0 1 1.62.21 10.43 10.43 0 0 1 1.35.54A9.47 9.47 0 0 1 28 9.09a.08.08 0 0 0 .07 0c.25.28.52.54.75.83a8.3 8.3 0 0 1 1.65 3.45 10.17 10.17 0 0 1 .2 1.44 16.85 16.85 0 0 1 0 2c0 .39-.07.78-.1 1.17a16 16 0 0 1-.61 2.92 8.91 8.91 0 0 1-1.48 2.83 24.45 24.45 0 0 1-2 2.31A48.44 48.44 0 0 0 23 30.43c-.39.49-.79 1-1.21 1.45a5.11 5.11 0 0 1-1.63 1.25ZM26 15.86Zm-4.36 8.79a5.68 5.68 0 0 0 1.92-.92c.23-.18.43-.39.65-.59l.08-.05a4.45 4.45 0 0 0 1.06-1.22 7.75 7.75 0 0 0 1.09-3.37c0-.25.06-.5.11-.75a.3.3 0 0 1 .38-.27 2.28 2.28 0 0 1 .77.27l.09.05-.16-.14a3.48 3.48 0 0 0-1.25-.69 9.1 9.1 0 0 0-2.19-.47 9.35 9.35 0 0 0-1.4 0 1.87 1.87 0 0 1-.41 0c-.15 0-.17-.11-.08-.23a1.12 1.12 0 0 1 .4-.28 3.46 3.46 0 0 1 1.3-.34 6.87 6.87 0 0 1 1.75.15l.26.06a.42.42 0 0 0-.12-.08 6 6 0 0 0-2.39-.58 7.32 7.32 0 0 0-2.28.24 6.36 6.36 0 0 0-3.06 1.72 7 7 0 0 0-1.36 2 6.1 6.1 0 0 1-.41.7.73.73 0 0 1-.7.37l.08.05a.94.94 0 0 0 1-.19c.17-.14.31-.31.48-.45s.4-.31.61-.47c.05 0 .12-.08.16 0s0 .13 0 .19c-.16.34-.34.68-.5 1a5.6 5.6 0 0 0-.52 2.17 11.14 11.14 0 0 0 .06 1.29 4.75 4.75 0 0 0 .14.63v.43a1.12 1.12 0 0 0 .23.55l.11.11a1.41 1.41 0 0 1 0-.5h.25A12.32 12.32 0 0 0 19.8 25a9.52 9.52 0 0 0 1.83-.35Zm-10.35-1.57a4.54 4.54 0 0 0 1.64.83 4.48 4.48 0 0 0 1 .17h.43c0-.14-.07-.28-.12-.41a10.78 10.78 0 0 0-1.06-2 7.88 7.88 0 0 0-1.28-1.54 2 2 0 0 0-.56-.39.32.32 0 0 0-.47.15 2.21 2.21 0 0 0-.34 1 2.76 2.76 0 0 0 .17 1.21 2.28 2.28 0 0 0 .59.98Zm11.48.58a6.89 6.89 0 0 1-2 .71 9.25 9.25 0 0 1-.92.12 3 3 0 0 1-.43 0 5.64 5.64 0 0 1-1.08-.1c-.05 0-.09 0-.09-.09v-.65a5.21 5.21 0 0 1 .21-1.1 5.49 5.49 0 0 1 1.05-2 6.51 6.51 0 0 1 2.19-1.7 5.8 5.8 0 0 1 1.77-.56 4.83 4.83 0 0 1 1.42 0 .09.09 0 0 1 .08.08c0 .19.05.38.07.57s0 .51 0 .76a4.84 4.84 0 0 1-.93 2.79 4.08 4.08 0 0 1-1.34 1.17Zm-.61-4.32c.54-.07 1.08-.11 1.62-.18a3.15 3.15 0 0 0 .61-.13.19.19 0 0 0 .16-.19.23.23 0 0 0-.14-.23.21.21 0 0 0-.11 0 1.51 1.51 0 0 0-.3 0c-.29.05-.57.09-.86.16a6.41 6.41 0 0 0-1.64.58h-.08a1.6 1.6 0 0 0-.51.42 3.33 3.33 0 0 1 1.25-.43Z"/></svg>
                             </span>
                        </div>
                    </div>
                </div>
                <div className="roadmap-item">
                    <div className="icon-wrapper">
                        <div className="icon">
                             <span>
                             <svg width="40" height="45" fill="#fff" style={{marginBottom: '-5px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 442.59 502.13"><path d="M419.9 15.32C401.78 1.73 377.45-.8 349.55 8a156 156 0 0 0-29 12.71C285.07 5.09 209.3-17.61 125 22.39A156.81 156.81 0 0 0 93 8C65.14-.8 40.81 1.73 22.69 15.32 3.81 29.48-3.65 51.59 1.68 77.58A110.2 110.2 0 0 0 13 107.81L8 163l18.67 10.89a256.52 256.52 0 0 0-3.13 40.44 139.4 139.4 0 0 0 4.74 35.22l-7-4.41v115.6L38 373.21 26.27 417.7l5.11 4.3a41.61 41.61 0 0 0 63.82 53.34l11 9.15 12.62-50.83 8.54 6.39a41.62 41.62 0 0 0 61.75 46.2l21.22 15.88h28l17.31-12.95A41.62 41.62 0 0 0 317 443.24l8.3-6.24 12.38 49.84 11.26-9.42a41.61 41.61 0 0 0 63.78-53.33l4.83-4-11.45-43.55 21.06-15.76v-115.6l-11 7a141 141 0 0 0 5.42-37.79 256.72 256.72 0 0 0-2.84-38.51l22-12.82-5.88-66a105.85 105.85 0 0 0 6.09-19.47c5.3-26-2.17-48.11-21.05-62.27ZM49.55 71.84 33 61.86c-.1-11.4 5.15-16.86 9.49-20.14 9.84-7.37 23.18-6.84 35.37-3.73ZM179.94 291.3h-28.43c-39.19 0-71.07-31.86-71.07-70.27 0-7.88 6.33-13.41 14.21-13.41h28.43a71.13 71.13 0 0 1 71.07 71.06c0 7.12-6.3 12.62-14.21 12.62Zm113.71 0h-28.42c-7.89 0-14.22-6.33-14.22-13.41a71.13 71.13 0 0 1 71.07-71.06h28.43c7.89 0 14.22 6.33 14.22 13.41a70.66 70.66 0 0 1-71.08 71.06ZM409.4 65.7l-13.89 8.36-30.27-36.19c12.05-3 25.16-3.42 34.86 3.85 4.8 3.6 10.72 9.93 9.3 23.98Z"/></svg>
                             </span>
                        </div>
                    </div>
                    <div className="copy">
                        <h3>Mega Aliens Collection</h3>
                        <p>Very limited collection only available to Alien Fam holders. More information coming soon.</p>
                    </div>
                </div>
            
            </div>

            <div className="in-progress">
                <p>This roadmap will keep growing!<br/> <a href="https://discord.com/invite/6AbcgVZMTf" target="_blank" rel="noreferrer"> Join the Alien Fam Discord</a> to receive the latest news and stay up to date.</p>
            </div>
            
        </RoadMapWrapper>
        </>
                
    );
  }
  
  export default RoadMap;

  const RoadMapWrapper = styled.div`
    background: #233632;
    position: relative;
    padding: 0 15px 100px;
    .ufo {
        position: absolute;
        top: -20%;
        right: 10%;
        z-index: 2;
        animation-name: floating;
        animation-duration: 3s;
        animation-iteration-count: infinite;
        animation-timing-function: ease-in-out;
        @media (max-width: 768px){
                top: -5%;
                max-width: 250px;
            }
    }
    @keyframes floating {
        0% { transform: translate(0,  0px); }
        50%  { transform: translate(0, 15px); }
        100%   { transform: translate(0, -0px); }   
    }
    .headline {
        h2 {
            color: #B5E8DD;
            font-family: 'Oswald', sans-serif;
            text-transform: uppercase;
            font-size: 6em;
            font-weight: 300;
            padding: 35px 0 0;
            text-align: center;
            @media (max-width: 768px){
                line-height: 1.2em;
            }
            span {
                color: #65ED26; 
            }
        }
        img {
            margin: 0 auto;
            display: block;
        }
    }
     
    .waves {
        width: 100%;
        top: 0;
        left: 0;
        position: absolute;
        z-index: 1;
        svg {
            position: absolute;
            width: 100%;
            bottom: 0;
            left: 0;
        }
    }

    .roadmap-timeline {
        max-width: 700px;
        margin: 80px auto 0;
        .roadmap-item {
            width: 50%;
            display: flex;
            align-items: stretch;
            transform: translateX(100%) translateX(-36px);
            @media (max-width: 768px){
                transform: translateX(0);
                width: 100%;
            }
            .icon-wrapper {
                position: relative;
                &:before {
                    content: '';
                    position: absolute;
                    width: 5px;
                    height: 100%;
                    background: #162421;
                    display: flex;
                    left: 50%;
                    transform: translateX(-50%);
                }
                .icon {
                    color: #fff;
                    width: 72px;
                    height: 72px;
                    background: #162421;
                    border-radius: 50%;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    span {
                        line-height: initial;
                    }
                }
            }
            .copy {
                color: #fff;
                flex: 1;
                padding: 0 15px 45px;
                .highlighted {
                    background: #162421;
                    padding: 10px 15px;
                    margin: 10px 0;
                    border-radius: 8px;
                    font-size: 1.4em;
                    font-weight: 300;
                    font-family: 'Oswald', sans-serif;
                    li {
                        list-style: none;
                        img {
                            display: inline;
                            width: 12px;
                            margin: 0 5px;
                        }
                    }
                }
                h3 {
                    font-family: 'Oswald', sans-serif;
                    font-weight: 300;
                    font-size: 3.2em;
                    line-height: 1em;
                    margin-bottom: 15px;
                }
            }
            &.done {
                .icon-wrapper {
                    &:before{
                        background: #65ED26;
                    }
                    .icon {
                        color: #000;
                        background: #65ED26;
                        }
                    }
                    svg {
                        fill: #000;
                        width: auto;
                        line-height: initial;
                        g {
                            fill: #000;
                        }
                    }
                }
            &:last-child {
                .icon-wrapper {
                    &:before{
                        background: rgb(18,38,34);
                        background: linear-gradient(0deg, rgba(18,38,34,0) 0%, rgba(22,36,33,1) 100%);
                        }
                    }
            }
            
        }
        
        .left {
            transform: translateX(36px);
            .copy {
                text-align: left;
                .highlighted {
                    text-align: left;
                }
                @media (max-width: 768px){
                    order: 1;
                }
            }
            .icon-wrapper {
                @media (max-width: 768px){
                    order: 0;
                }
                
            }
            @media (max-width: 768px){
                transform: translateX(0);
                width: 100%;
            }
        }
    }
    .in-progress {
        max-width: 480px;
        margin: 35px auto;
        display: block;
        p {
            font-size: 1.4em;
            color: #fff;
            text-align: center;
            a {
                color: #65ED26;
                text-decoration: none;
            }
        }
    }


    .countdown-inner {
        span {
            font-size: 25px;
            margin: 0;
            b {
                font-size: 0.5em;
                font-weight: normal;
            }
        }
        &-text {
            font-size: 1em;
        }
    }
    .inner-mint-block {
        h2 {
            font-size: 2em;
        }
        a {
            font-size: 18px;
        }
        p {
            font-size: 16px;
        }
    }

  `
  